<template>
    <div>
        <base-modal id="modalContactWhatsapp">
            <div class="modal-header">
                <user-picture :size="'-medium'" :border="'-border-light'" :user="user" v-if="user" />

                <h2 class="title">Contato <span class="color-alt">por WhatsApp</span></h2>
                <p class="subtitle">Informe os seus dados no formulário.</p>
                <i class="icon fab fa-whatsapp" aria-hidden="true"></i>
            </div>
            <div class="modal-body">
                <form class="form">
                    <div class="input-group">
                        <input class="input -xlarge" type="text" v-model="name" placeholder="Qual seu nome?" />
                    </div>
                    <div class="input-group">
                        <input
                            class="input -xlarge"
                            type="tel"
                            v-model="phone"
                            v-mask="['(##) ####-####', '(##) #####-####']"
                            placeholder="Qual o seu WhatsApp?"
                        />
                    </div>
                    <div class="input-group">
                        <textarea
                            class="input -xlarge"
                            type="text"
                            v-model="message"
                            placeholder="Olá, tenho interesse no imóvel Park House Residence que encontrei no seu site. Poderia me dar mais informações sobre a forma de pagamento?"
                        ></textarea>
                    </div>
                    <div class="actions">
                        <button class="button -block -xlarge -contrast" type="button">
                            Enviar
                        </button>
                    </div>
                </form>
            </div>
        </base-modal>
    </div>
</template>

<script>
    import BaseModal from '@/Components/BaseModal'
    import UserPicture from '@/Components/User/UserPicture'

    export default {
        components: {
            BaseModal,
            UserPicture,
        },

        props: {
            user: {
                type: Object,
                require: true,
                default() {
                    return {}
                },
            },
        },

        data() {
            return {
                name: null,
                phone: null,
                email: null,
                message: null,
            }
        },

        computed: {
        },

        methods: {
            close() {
                this.$root.$emit('hideModal', 'modalContactWhatsapp')
            },

            notification() {
                this.close()
                this.$root.$emit('showModal', 'modalContactNotification')
            },
        },
    }
</script>

<style lang="stylus" scoped></style>
